/**
 * @prettier
 */

import React from 'react';
import moment from 'moment';
import { Link } from '@zola/zola-ui/src/components/Link';
import OrderPreview from '../SamplePreview/OrderPreview';
import styles from './styles.module.less';

const SampleOrderTile = ({ createdAt, project, fetchedProject, width }) => {
  const dateText = moment(createdAt).format('MMMM D, YYYY');

  if (!project) {
    return null;
  }

  const leadCustomization = fetchedProject.customizations.find(customization => customization.lead);

  if (!leadCustomization) {
    return null;
  }

  const isSingleSample = project.single_sample && leadCustomization.quantity === 1;

  if (!isSingleSample) {
    return null;
  }

  return (
    <div className={styles.orderTileBox} style={{ maxWidth: width }}>
      <div className={styles.orderTilePreview} style={{ width: width + 16, height: width + 16 }}>
        <OrderPreview width={width} page={leadCustomization.pages[0]} />
      </div>
      <div className={styles.orderTileDetails}>
        <div className={styles.orderTileTitle}>{fetchedProject.name}</div>
        <div className={styles.orderTileDate}>Ordered {dateText}</div>
        <div className={styles.orderTileLink}>
          <Link href={`/wedding-planning/projects/finished#${fetchedProject.uuid}`} arrow>
            View Order
          </Link>
        </div>
      </div>
    </div>
  );
};

SampleOrderTile.defaultProps = {
  width: 175,
};

export default SampleOrderTile;
